<div>
  <canvas #reviewerchart style="height:450px;width:620px;">{{chart}}</canvas>
</div>
